{
  "generic": "Sorry, something went wrong. Please try again. If you're still having issues, please contact our support team.",
  "rate_limited": {
    "title": "Too many attempts",
    "message": "Please wait a few minutes before trying again."
  },
  "forms": {
    "number": {
      "numeric": "Please enter a valid number",
      "min": "Must be {min, number} or more",
      "min_exclusive": "Must be more than {min, number}",
      "max": "Must be {max, number} or less",
      "integer": "Please enter a whole number"
    },
    "string": {
      "non_empty": "This field can't be empty",
      "min": "Must be at least {min} characters",
      "max": "Must be no more than {max} characters",
      "email": "Must be a valid email address"
    },
    "array": {
      "min": "Must select at least {min}",
      "max": "Must select no more than {max}"
    },
    "min_exceeds_max": "Maximum must be greater than minimum",
    "min_or_max_required": "Must provide a min or max",
    "slug": "Use lowercase letters, numbers, and hyphens only",
    "slugStartingWithLetter": "Must start with a letter",
    "required": "This field is required",
    "duplicate_handle": "This handle is already in use",
    "validation_failed": "Please fix the {number, plural, =1 {validation error} other {# validation errors}} highlighted."
  },
  "forbidden": "You don't have permission to perform this action.",
  "conflict": "This change conflicts with the current state. Please refresh and try again."
}
